import { useQuery } from "@tanstack/react-query";
import { api } from "./api";
import { useOrg } from "./session";

/** useInboxCounts: conversations waiting for a person, and unread ones (sidebar badge). */
export function useInboxCounts(enabled = true) {
  const { base, orgId } = useOrg();
  return useQuery({
    queryKey: [orgId, "threads", "counts"],
    queryFn: () => api<{ needs_person: number; unread: number }>(`${base}/threads/counts`),
    refetchInterval: 30_000, staleTime: 10_000, enabled,
  });
}
